import Select from "../../../UI/Form/Select/Select";
import Input from "../../../UI/Form/Input/Input";
import { getToDateType } from "../../../store/actions/queryBuilder/getRange";
import useDebounceChange from "../../../hooks/useDebounceChange";
import DatePicker from "../../../UI/DatePicker/DatePicker";
import {
  getCurrentDateString,
  setSpecificTimezone,
} from "../../../utils/formatters/dateFormatter";
import { getUserSelectedDateOption } from "./customDateUtils";
import useToDateFiltersLocalState from "./useToDateFiltersLocalState";

export default function RollingDates(props) {
  const {
    selectProps,
    type,
    recentMonthsChange,
    toDateType,
    label,
    defaultRollingDate = null,
    activeTabUuid,
    selectedDateType,
    saveStickyDatesToStore,
    dateFiltersConfig,
    dateConfig,
    defaultRollingDateCount,
    recentSelectedDatePreset,
    overPrimary,
    domain,
  } = props;

  const { localState, setLocalState } = useToDateFiltersLocalState(
    dateConfig?.tabChanged,
    {
      count: defaultRollingDateCount,
      ...(getUserSelectedDateOption(dateFiltersConfig, activeTabUuid) ?? {}),
    }
  );

  const rollingDate = {
    ...(defaultRollingDate ?? {}),
    ...localState,
    ...(recentSelectedDatePreset ?? {}),
  };

  const isToDateType = (toDateType + "").includes("_TO_DATE");
  const showCountInput = isToDateType || rollingDate;

  const { debounce } = useDebounceChange();

  function getRollingRange(endDate, count) {
    if (!Number.isInteger(count)) {
      return;
    }

    const query = {
      toDateType,
      toDateCount: count,
    };

    // using same function for toDateType from chart config
    return getToDateType(query, { end: { value: endDate } }, true);
  }

  // Handle rolling date count change, debounced api call
  function applyRollingDateCount(e) {
    const endDate = isToDateType
      ? domain === "ccg"
        ? setSpecificTimezone()
        : getCurrentDateString()
      : rollingDate?.to;
    const range = getRollingRange(endDate, +e.target.value);

    const rolling = {
      ...rollingDate,
      from: range.start,
      to: range.end,
      count: +e.target.value,
    };

    debounce(() => recentMonthsChange(rolling));
    if (saveStickyDatesToStore) {
      saveStickyDatesToStore(selectedDateType, rolling);
    }
    setLocalState(rolling);
    e.preventDefault();
    e.stopPropagation();
  }

  // Handle change recent days/weeks/months/quarters/years
  function onRollingDateChange(option) {
    const count = rollingDate.count;
    const range = getRollingRange(option.to, count);

    // if rolling date count already set then api call on rolling type chage
    if (range) {
      const rolling = {
        ...option,
        from: range.start,
        to: range.end,
        count,
      };

      recentMonthsChange(rolling);
      if (saveStickyDatesToStore) {
        saveStickyDatesToStore(selectedDateType, rolling);
      }
      setLocalState(rolling);
    }
  }

  const options = (selectProps ?? {})[type]?.options ?? [];
  // reset old value when user change rolling type option
  function getOption() {
    return options.find((option) => option.label === rollingDate?.label);
  }

  function renderListOrPicker() {
    if (isToDateType) {
      return null;
    }

    return (
      <>
        <br />
        {selectProps ? (
          <Select
            options={options}
            onChange={onRollingDateChange}
            getOptionValue={(o) => o.from}
            placeholder={selectProps[type]?.placeholder}
            value={getOption()}
            label={`Most Recent ${label}`}
            overPrimary={overPrimary}
            cy={`select-rolling-${type}`}
          />
        ) : (
          <DatePicker
            onChange={(e) => onRollingDateChange({ to: e.target.value })}
            value={rollingDate?.to}
          />
        )}
      </>
    );
  }

  return (
    <>
      {renderListOrPicker()}

      {showCountInput && (
        <>
          <br />
          <Input
            label={`${label}s count`}
            onChange={applyRollingDateCount}
            type="number"
            min="1"
            value={rollingDate.count}
            overPrimary={overPrimary}
          />
        </>
      )}
    </>
  );
}
